/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entrylinkmissing2Inputs */

const en_entrylinkmissing2 = /** @type {(inputs: Entrylinkmissing2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the link.`)
};

const de_entrylinkmissing2 = /** @type {(inputs: Entrylinkmissing2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib den Link an.`)
};

/**
* | output |
* | --- |
* | "Enter the link." |
*
* @param {Entrylinkmissing2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entrylinkmissing2 = /** @type {((inputs?: Entrylinkmissing2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entrylinkmissing2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entrylinkmissing2(inputs)
	return de_entrylinkmissing2(inputs)
});
export { entrylinkmissing2 as "entryLinkMissing" }